// src/components/Login.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, {
                email,
                password,
            });

            if (response.data.message === "Login successful") {
                localStorage.setItem("token", response.data.token);
                navigate("/dashboard");
            }
        } catch (err) {
            console.error(err);
            setError("Email or password incorrect");
        }
    };

    return (
        <div className="login-page">
            <div className="login-box">
                <div className="card-login">
                    <div className="card-body login-card-body">
                        <p className="login-box-msg">Login Halaman Admin</p>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleLogin();
                            }}
                        >
                            <div className="input-group mb-3">
                                <input
                                    type="text"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />

                                {/* <form onSubmit={login}>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="enter your email"
                  required
                /> */}
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-envelope" />
                                    </div>
                                </div>
                            </div>
                            <div className="input-group mb-3">
                                <input
                                    type="password"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />

                                {/* <input
                  className="form-control"
                  type="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="enter your password"
                  required
                /> */}
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-lock" />
                                    </div>
                                </div>
                            </div>
                            <button className="btn-login btn-block" type="submit">
                                Submit
                            </button>
                            {error && <p style={{ color: "red" }}>{error}</p>}
                            {/* {message && <p className="message-msg">{message}</p>} */}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
